import { SlashCommand } from './types';

export const systemCommands: SlashCommand[] = [
    { id: 'clear', name: 'Clear Chat', trigger: '/clear', description: 'Clear the current chat history', category: 'System', icon: 'fa-trash-can', mode: 'ui', integration: 'System' },
    { id: 'mcp', name: 'MCP Test', trigger: '/mcp', description: 'Test VPS MCP Backend', category: 'System', icon: 'fa-server', mode: 'ui', integration: 'System' },
    { id: 'terminal', name: 'Terminal', trigger: '/terminal', description: 'Open VPS Terminal', category: 'System', icon: 'fa-terminal', mode: 'ui', integration: 'System' }
];
